interface RecallOverlayProps {
  pageNumber: number;
  onReveal: () => void;
}

export function RecallOverlay({ pageNumber: _, onReveal }: RecallOverlayProps) {
  return (
    <div className="absolute inset-0 z-10 flex flex-col items-center justify-center font-sans">
      {/* Step 1 node */}
      <div className="flex flex-col items-center gap-1.5">
        <div className="flex h-7 w-7 items-center justify-center rounded-full bg-primary text-xs font-semibold text-primary-foreground">
          1
        </div>
        <span className="text-xs font-medium text-foreground">Recite</span>
      </div>

      {/* Edge */}
      <div className="h-8 w-px bg-foreground/20" />

      {/* Step 2: the button IS the node */}
      <button
        type="button"
        onClick={onReveal}
        className="inline-flex items-center gap-2.5 rounded-full border-2 border-foreground/25 px-7 py-2.5 text-sm font-medium text-foreground/70 transition-all hover:border-primary hover:text-primary active:scale-[0.97] cursor-pointer"
      >
        <span className="flex h-5 w-5 items-center justify-center rounded-full border border-current text-[10px] font-semibold">
          2
        </span>
        Reveal & rate
      </button>
    </div>
  );
}
